module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("reasontype", [_c('span', {
    staticClass: "floatr advice-tip"
  }, [_vm._v("采纳以下"), _c('i', {
    staticClass: "red"
  }, [_vm._v(" " + _vm._s(_vm.adviceSuggestNum))]), _vm._v(" 个建议预计展现量提升"), _c('i', {
    staticClass: "red"
  }, [_vm._v(" " + _vm._s(_vm.adviceEstiAddAdpv))]), _vm._v("，点击量提升"), _c('i', {
    staticClass: "red"
  }, [_vm._v(" " + _vm._s(_vm.adviceEstiAddAdclick))])])]), _c('div', {
    staticClass: "advice-table"
  }, [_c('HeadFixedTable', {
    attrs: {
      "columns": _vm.currentColumns,
      "checkbox": _vm.hasCheckbox,
      "check_all": _vm.hasCheckbox,
      "checkbox_length": 1000,
      "isAllChecked": _vm.isAllChecked,
      "hasPagination": true,
      "list": _vm.currentList
    },
    on: {
      "pageChange": _vm.pageChange
    },
    scopedSlots: {
      "adjust_quota-td": function(props) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!props.item.priceEdit),
            expression: "!props.item.priceEdit"
          }]
        }, [_vm._v(_vm._s(props.item.submit_quota))]), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (props.item.priceEdit),
            expression: "props.item.priceEdit"
          }],
          staticStyle: {
            "position": "relative"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.stop($event)
            }
          }
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (props.item.submit_quota),
            expression: "props.item.submit_quota"
          }],
          staticClass: "size-small",
          class: {
            'error': _vm.isQuotaUnvalid(props.item)
          },
          attrs: {
            "type": "text",
            "placeholder": '最多保留两位小数'
          },
          domProps: {
            "value": _vm._s(props.item.submit_quota)
          },
          on: {
            "keyup": function($event) {
              if (_vm._k($event.keyCode, "enter", 13)) { return; }
              _vm.saveQuota(props.item)
            },
            "input": function($event) {
              if ($event.target.composing) { return; }
              props.item.submit_quota = $event.target.value
            }
          }
        }), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (props.item.quotaErrorShow && _vm.quotaUnvalidMsg != ''),
            expression: "props.item.quotaErrorShow && quotaUnvalidMsg != ''"
          }],
          staticClass: "warning-tip"
        }, [_vm._v(_vm._s(_vm.quotaUnvalidMsg)), _c('i', {
          staticClass: "fa fa-times",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.item.quotaErrorShow = false
            }
          }
        })])]), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isEditable && !props.item.status),
            expression: "isEditable && !props.item.status"
          }],
          staticClass: "btn btn-icon",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.openQuota(props.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-edit"
        })])]
      },
      "delete-td": function(props) {
        return [_vm._t("delete", null, {
          item: props.item
        })]
      },
      "status-td": function(props) {
        return [_vm._t("status", null, {
          item: props.item
        })]
      }
    }
  }, [_c('v-tooltip', {
    attrs: {
      "tip": '建议预算是通过流量预估给出的建议，若修改不得低于当前预算，否则达不到优化效果',
      "pos": "left"
    },
    slot: "adjust_quota"
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "margin-left": "5px"
    }
  })])], 1)], 1)], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e718d5d2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e718d5d2!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/web/budget_advice_table.vue
// module id = 807
// module chunks = 0